import React, {RefObject, useEffect, useState} from 'react';
import './WizardChangeAspect.css';
import {cn} from '@bem-react/classname';
import {IClassNameProps} from '@bem-react/core';
import {useTranslation} from 'react-i18next';
import {useDispatch, useSelector} from 'react-redux';
import {KitchenService} from "../../../../3d/services/KitchenService/KitchenService";
import {TChangeAspectData} from "../../../../../common-code/types/project/TChangeAspectData";
import {TScreenFrameData} from "../../../../3d/types/TScreenFrameData";
import {TScreenSizes} from "../../../../types/TScreenSizes";
import {useScreenSizes} from "../../../../hooks/useScreenSizes";
import {TWizardUIOptions} from "../../../../types/TWizardUIOptions";
import {AppState} from "../../../../redux/AppStore";
import {PROCESS_CHANGE_ASPECT} from "../../../../constants";
import {
    KITCHEN_SIZES_TYPE_ALL,
    KITCHEN_SIZES_TYPE_NONE,
    KITCHEN_VIEW_SKETCH,
    KITCHEN_VIEW_VISUAL
} from "../../../../../common-code/constants";
import {Popup} from "../../../components/Popup";
import {Svg} from "../../../components/Svg";
import {Button} from "../../../components/Button";
import {generateMods} from "../../../../helpers";

export const cnWizardChangeAspect = cn('WizardChangeAspect');
export interface IWizardChangeAspectProps extends IClassNameProps {
    service: KitchenService;
    editorRef: RefObject<HTMLDivElement>;
    changeAspectData: TChangeAspectData;
}
type TCanvasPosition = {
    x: number;
    y: number;
    width: number;
    height: number;
    screenWidth: number;
    screenHeight: number;
};

export const WizardChangeAspect: React.FC<IWizardChangeAspectProps> = ({service, className, editorRef, changeAspectData}) => {
    const {t} = useTranslation();
    const screenFrameData: TScreenFrameData = service.getScreenFrameData();
    const [canvasPosition, setCanvasPosition] = useState<TCanvasPosition | undefined>(undefined);
    const screenSizes: TScreenSizes = useScreenSizes();
    const dispatch = useDispatch();
    const [hoverItem, setHoverItem] = useState<string | null>(null);
    const kitchenOptions: TWizardUIOptions = useSelector((state: AppState) => state.wizard.options);

    useEffect(() => {
        if (editorRef.current) {
            setCanvasPosition({
                x: editorRef.current.offsetLeft,
                y: editorRef.current.offsetTop,
                width: editorRef.current.clientWidth,
                height: editorRef.current.clientHeight,
                screenWidth: screenSizes.width,
                screenHeight: screenSizes.height
            });
        }
    }, [editorRef, screenSizes.height, screenSizes.width]);

    const closeChangeAspect = () => {
        dispatch({
            type: PROCESS_CHANGE_ASPECT,
            payload: undefined,
        });
    }
    const showAll = () => {
        service.showAll();
    }
    const changeViewType = () => {
        if (kitchenOptions.viewType === KITCHEN_VIEW_VISUAL) {
            service.setViewType(KITCHEN_VIEW_SKETCH);
        } else {
            service.setViewType(KITCHEN_VIEW_VISUAL);
        }
    }
    const toggleSizes = () => {
        if (kitchenOptions.sizesType === KITCHEN_SIZES_TYPE_NONE) {
            service.setSizeType(KITCHEN_SIZES_TYPE_ALL);
        } else {
            service.setSizeType(KITCHEN_SIZES_TYPE_NONE);
        }
        service.rebuildScene();
    }
    const resetChangeAspect = () => {
        service.resetChangeAspect(changeAspectData);
        closeChangeAspect();
    }
    const applyChangeAspect = () => {
        service.applyChangeAspect(changeAspectData);
        closeChangeAspect();
    }

    if (!canvasPosition) {
        return null;
    }
    return (
        <div className={cnWizardChangeAspect({}, [className])}>
            <div className={cnWizardChangeAspect('Title')}
            style={{
                left: canvasPosition.x + screenFrameData.start.x + 20,
                top: canvasPosition.y + screenFrameData.start.y + 20,
                width: screenFrameData.width - 40
            }}>
                {t('Режим установки камеры для снимка')}
            </div>
            <div className={cnWizardChangeAspect('Cape', {type: 'top'})}
                 style={{
                     top: 0,
                     left: 0,
                     width: canvasPosition.screenWidth,
                     height: canvasPosition.y
            }}
            >
            </div>
            <div className={cnWizardChangeAspect('Cape', {type: 'right'})}
                 style={{
                     top: canvasPosition.y,
                     bottom: (canvasPosition.screenHeight - (canvasPosition.y + canvasPosition.height)),
                     right: -(canvasPosition.screenWidth - (canvasPosition.x + canvasPosition.width)),
                     width: canvasPosition.screenWidth - (canvasPosition.x + canvasPosition.width),
                     height: canvasPosition.screenHeight
            }}
            >
            </div>
            <div className={cnWizardChangeAspect('Cape', {type: 'bottom'})}
                 style={{
                     left: 0,
                     right: 0,
                     bottom: -(canvasPosition.screenHeight - (canvasPosition.y + canvasPosition.height)),
                     width: canvasPosition.screenWidth,
                     height: (canvasPosition.screenHeight - (canvasPosition.y + canvasPosition.height))
                 }}
            >
            </div>
            <div className={cnWizardChangeAspect('Cape', {type: 'left'})}
                 style={{
                     left: 0,
                     top: canvasPosition.y,
                     bottom: (canvasPosition.screenHeight - (canvasPosition.y + canvasPosition.height)),
                     width: canvasPosition.x,
                     height: canvasPosition.screenHeight
                 }}
            >
            </div>


            <div className={cnWizardChangeAspect('Cape', {type: 'top'})}
                 style={{
                     top: canvasPosition.y,
                     left: canvasPosition.x,
                     width: canvasPosition.width,
                     height: screenFrameData.start.y
                 }}
            >
            </div>
            <div className={cnWizardChangeAspect('Cape', {type: 'right'})}
                 style={{
                     top: canvasPosition.y + screenFrameData.start.y,
                     left: canvasPosition.x + screenFrameData.end.x,
                     width: (canvasPosition.width - screenFrameData.end.x),
                     height: canvasPosition.height - (screenFrameData.start.y + (canvasPosition.height - screenFrameData.end.y))
                 }}
            >
            </div>
            <div className={cnWizardChangeAspect('Cape', {type: 'bottom'})}
                 style={{
                     left: canvasPosition.x,
                     top: (canvasPosition.y + screenFrameData.end.y),
                     width: canvasPosition.width,
                     height: (canvasPosition.height - screenFrameData.end.y)
                 }}
            >
            </div>
            <div className={cnWizardChangeAspect('Cape', {type: 'left'})}
                 style={{
                     left: canvasPosition.x,
                     top: canvasPosition.y + screenFrameData.start.y,
                     width: screenFrameData.start.x,
                     height: canvasPosition.height - (screenFrameData.start.y + (canvasPosition.height - screenFrameData.end.y))
                 }}
            >
            </div>
            <div className={cnWizardChangeAspect('ButtonsWrapper')}
                 style={{
                     left: canvasPosition.x + screenFrameData.start.x + 20,
                     top: canvasPosition.y + screenFrameData.end.y - 60,
                     height: 38,
                     width: screenFrameData.width - 40,
                 }}
            >
                <div className={cnWizardChangeAspect('Buttons')}>
                    <div
                        key={'toggleSizes'}
                        className={cnWizardChangeAspect('Button', {
                            ...generateMods({
                                hover: {state: hoverItem === 'toggleSizes', mods: {cursor: 'pointer'}}
                            })
                        })}
                        onClick={toggleSizes}
                        onMouseEnter={() => {
                            setHoverItem('toggleSizes')
                        }}
                        onMouseLeave={() => {
                            setHoverItem(null)
                        }}
                    >
                        <Svg icon={'sizes'} className={cnWizardChangeAspect('ButtonIcon', {
                            ...generateMods({
                                hover: {state: hoverItem === 'toggleSizes', mods: {fill: 'red'}},
                                active: {
                                    state: kitchenOptions.sizesType === KITCHEN_SIZES_TYPE_ALL,
                                    mods: {fill: 'red'}
                                }
                            })
                        })} label={t('Показать размеры') || undefined}
                        />
                        {
                            hoverItem === 'toggleSizes' ?
                                <Popup
                                    className={cnWizardChangeAspect('Popup')}
                                    position={{x: 36, y: 36}}
                                    active={hoverItem === 'toggleSizes'}
                                >
                                    <div className={cnWizardChangeAspect('HeaderPopup')}>{t('Показать размеры')}</div>
                                </Popup> : null
                        }
                    </div>
                    <div
                        key={'viewType'}
                        className={cnWizardChangeAspect('Button', {
                            ...generateMods({
                                hover: {state: hoverItem === 'viewType', mods: {cursor: 'pointer'}}
                            })
                        })}
                        onClick={changeViewType}
                        onMouseEnter={() => {
                            setHoverItem('viewType')
                        }}
                        onMouseLeave={() => {
                            setHoverItem(null)
                        }}
                    >
                        <Svg icon={'lines'} className={cnWizardChangeAspect('ButtonIcon', {
                            ...generateMods({
                                hover: {state: hoverItem === 'viewType', mods: {fill: 'red'}},
                                active: {
                                    state: kitchenOptions.viewType === KITCHEN_VIEW_SKETCH,
                                    mods: {fill: 'red'}
                                }
                            })
                        })} label={t('Скетч вид') || undefined}
                        />
                        {
                            hoverItem === 'viewType' ?
                                <Popup
                                    className={cnWizardChangeAspect('Popup')}
                                    position={{x: 36, y: 36}}
                                    active={hoverItem === 'viewType'}
                                >
                                    <div className={cnWizardChangeAspect('HeaderPopup')}>{t('Скетч вид')}</div>
                                </Popup> : null
                        }
                    </div>
                    <div
                        key={'showAll'}
                        className={cnWizardChangeAspect('Button', {
                            ...generateMods({
                                hover: {state: hoverItem === 'showAll', mods: {cursor: 'pointer'}}
                            })
                        })}
                        onClick={showAll}
                        onMouseEnter={() => {
                            setHoverItem('showAll')
                        }}
                        onMouseLeave={() => {
                            setHoverItem(null)
                        }}
                    >
                        <Svg icon={'kitchen-construct'} className={cnWizardChangeAspect('ButtonIcon', {
                            ...generateMods({
                                hover: {state: hoverItem === 'showAll', mods: {fill: 'red'}},
                            })
                        })} label={t('Показать все') || undefined}
                        />
                        {
                            hoverItem === 'showAll' ?
                                <Popup
                                    className={cnWizardChangeAspect('Popup')}
                                    position={{x: 36, y: 36}}
                                    active={hoverItem === 'showAll'}
                                >
                                    <div className={cnWizardChangeAspect('HeaderPopup')}>{t('Показать все')}</div>
                                </Popup> : null
                        }
                    </div>
                    <Button className={cnWizardChangeAspect('Reset', [cnWizardChangeAspect('Button')])}
                            type={'button'}
                            leftIcon={{path: 'kitchen-construct', width: 20, height: 20, fill: 'lightBlack', marginRight: 6}}
                            mods={{
                                mods: {bkg: "white", color: "lightGray", border: "lightGray", fill: "lightBlack",},
                                hover: {mods: {bkg: "lightGray", color: "lightGray", fill: "black"},},
                            }}
                            callBack={resetChangeAspect}
                            text={t('Сбросить')}
                    />
                    <Button className={cnWizardChangeAspect('Apply', [cnWizardChangeAspect('Button')])}
                            type={'button'}
                            leftIcon={{path: 'check', width: 20, height: 20, marginRight: 6}}
                            mods={{
                                mods: {bkg: "white", color: "lightGreen", border: "lightGreen", fill: "lightGreen",},
                                hover: {mods: {bkg: "lightGreen", color: "white", fill: "white"},},
                            }}
                            callBack={applyChangeAspect}
                            text={t('Применить')}
                    />
                </div>
            </div>
            <div className={cnWizardChangeAspect('CloseWrapper')}
                 style={{
                     left: canvasPosition.x + screenFrameData.end.x - 40,
                     top: canvasPosition.y + screenFrameData.start.y + 20,
                 }}>
                <Button
                    className={cnWizardChangeAspect('Close')}
                    type={'button'}
                    leftIcon={{path: 'close', width: 20, height: 20}}
                    mods={{
                        mods: {fill: 'black'},
                        hover: {mods: {fill: 'red'}}
                    }}
                    callBack={closeChangeAspect}
                />
            </div>
        </div>
    );
}